import { rootRouteName } from "config/menuConfig";

let cache = {};
const getAuthBizLineKey = 'getAuthBizLineKey';
const RootStateKey = "RootState";
const menusKeyPrefix = "menus";

function filterMenus(route, sfCustoms, rootPath = '/') {
    let path = rootPath + route.path;
    if (!sfCustoms.check(path)) {
        route.meta = route.meta || {};
        Object.assign(route.meta, { notMenu: true });
    } else {
        if (route.children && route.children.length) {
            route.children.forEach((routeItem) => {
                filterMenus(routeItem, sfCustoms, path + '/');
            });
        }
    }
}

export const getActiveMenuInfo = function(currentRoute) {
    let info = {};
    if (currentRoute.meta && currentRoute.meta.activeName) {
        info.activeName = currentRoute.meta.activeName;
    } else if (!currentRoute.meta || !currentRoute.meta.notMenu) {
        info.activeName = currentRoute.name;
    }
    let matches = currentRoute.matched;
    if (matches && matches[0] && matches[0].name === rootRouteName) {
        if (matches[2] && matches[2].name) {
            info.openNames = [matches[2].name];
        }
    }
    return info;
}

export const getMenus = function(routes, currentRoute, sfCustoms, bizUser) {
    let matches = currentRoute.matched;
    if (matches && matches[0] && matches[0].name === rootRouteName && matches[1] && matches[1].meta && matches[1].meta.name) {
        let bizLineDefaultRouteName = matches[1].meta.name;
        let key = menusKeyPrefix + bizLineDefaultRouteName;
        key += (bizUser && bizUser.id || 'nokey');
        if (cache && cache[key]) {
            return cache[key];
        }
        let menus = [];
        let rootRoute = getRootRoute(routes);
        let bizLineHomeRoute = rootRoute.children.find((route) => {
            if (route && route.meta && route.meta.name) {
                return route.meta.name === bizLineDefaultRouteName;
            }
        });
        if (bizLineHomeRoute && bizLineHomeRoute.children && bizLineHomeRoute.children.length) {
            filterMenus(bizLineHomeRoute, sfCustoms);
            menus = bizLineHomeRoute.children;
        }
        cache[key] = menus;
        return cache[key];
    }
    return [];
}

export const getRootRoute = function(routes) {
    if (cache && cache[RootStateKey]) {
        return cache[RootStateKey];
    } else {
        let rootRoute = routes.find(routeItem => {
            return routeItem.name === rootRouteName;
        });
        cache[RootStateKey] = rootRoute;
        return rootRoute;
    }
}

export const getAuthBizLines = function(routes, bizUser) {
    let key = (bizUser && bizUser.id || 'nokey') + getAuthBizLineKey;
    if (cache && cache[key]) {
        return cache[key];
    } else {
        let result = [];
        if (bizUser && routes && routes.length) {
            let authBizLines = bizUser.authBizlineInfos;
            if (authBizLines && authBizLines.length) {
                let rootRoute = getRootRoute(routes);
                if (rootRoute.children && rootRoute.children.length) {
                    result = rootRoute.children
                        .filter(childRoute => {
                            return authBizLines.find(authBizLine => {
                                return authBizLine.bizline === childRoute.meta.bizLineValue;
                            });
                        })
                        .map(childRoute => {
                            return {
                                name: childRoute.meta.bizName,
                                value: childRoute.meta.name
                            };
                        });
                }
            }
        }
        cache[getAuthBizLineKey] = result;
        return result;
    }
};


// WEBPACK FOOTER //
// ./src/utils/menu.js